// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["defaultVendors-node_modules_regenerator-runtime_runtime_js-node_modules_requestidlecallback-p-8d3cd4"], function() { return __webpack_require__("./vendor.index.ts"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
